module.exports = __webpack_public_path__ + "static/media/samfunnsdialog_android_popup.7fe08a09.png";